//View
function MakeViewActive(button) {
  const spans = button.querySelectorAll('.cells_d2 span');
  let currentIndex = -1;
  spans.forEach((span, i) => {
    if (span.classList.contains('filled')) currentIndex = i;
  });
  if (currentIndex === spans.length - 1) {
    spans.forEach((span) => span.classList.remove('filled'));
    spans[0].classList.add('filled');
  } else {
    spans[currentIndex + 1].classList.add('filled');
  }
}

// ⚠️ MODEL: NADA DE `:has()` NI DE ESPERAR A QUE CARGUE LA FOTO (Daniel, 26-ago-2026: "cuando le doy
// a ver imagenes de model... no funciona bien el scroll, se queda pillado y de repente aparecen
// muchas de golpe").
//
// Habia dos cosas juntas:
//   1) El cambio se hacia con `.new_options_dd:has(.model_d1.active_d1)`. `:has()` obliga al
//      navegador a repasar el estilo de TODA la rejilla (50 fichas, 300 fotos) cada vez que algo
//      cambia dentro, y dentro cambia todo el rato (fotos que cargan, animaciones de entrada). De
//      ahi los tirones. Ahora se pone una clase de verdad en el contenedor: cuesta cero.
//   2) La segunda foto de cada ficha es `loading=lazy`. Al encender Model, la ficha se queda en
//      blanco hasta que esa foto se descarga, y luego aparecen varias de golpe. Ahora, con Model
//      encendido, la segunda foto se pide con antelacion (600px antes de llegar), no todas a la vez.
function MakeModelActive(element) {
  element.classList.toggle('active_d1');
  var encendido = element.classList.contains('active_d1');
  var caja = element.closest('.new_options_dd') || document.querySelector('.new_options_dd');
  if (caja) caja.classList.toggle('modelo_dd', encendido);
  if (encendido) adelantarFotosModelo();
}

var vigilanteModelo = null;
function adelantarFotosModelo() {
  var caja = document.querySelector('.new_options_dd.modelo_dd');
  if (!caja) return;

  function pedir(ficha) {
    var img = ficha.querySelector('.product-block__image--secondary img, .image-label-wrap > div:nth-child(2) img');
    if (!img || img.dataset.modeloListo === '1') return;
    img.dataset.modeloListo = '1';
    img.setAttribute('decoding', 'async');
    if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
  }

  if (!('IntersectionObserver' in window)) {
    caja.querySelectorAll('.product-block').forEach(pedir);
    return;
  }
  if (!vigilanteModelo) {
    vigilanteModelo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        pedir(e.target);
        vigilanteModelo.unobserve(e.target);
      });
    }, { rootMargin: '600px 0px' });
  }
  caja.querySelectorAll('.product-block').forEach(function (f) { vigilanteModelo.observe(f); });
}

/* Si la rejilla se repinta (filtros, "cargar mas"), se vuelven a vigilar las fichas nuevas. */
document.addEventListener('DOMContentLoaded', function () {
  var caja = document.querySelector('.new_options_dd');
  if (!caja || !('MutationObserver' in window)) return;
  var reloj;
  new MutationObserver(function () {
    clearTimeout(reloj);
    reloj = setTimeout(function () {
      if (document.querySelector('.new_options_dd.modelo_dd')) adelantarFotosModelo();
    }, 200);
  }).observe(caja, { childList: true, subtree: true });
});
